const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

//const BackofficeBFFForeign: string ="https://backofficebff-ru.dev.lcwaikiki.com/backofficebff/service/api/";

export const CargoCommand: any = {
    PostCargoTransferData: Backofficebff + '/v1/cargo/transferdata',
    AddShippingFeeManagement: Backofficebff + '/v1/foreign/cargocompany/create',
    UpdateShippingFeeManagement: Backofficebff + '/v1/foreign/cargocompany/create',
    GetShippingFeeManagementListByFilter: Backofficebff + '/v1/foreign/cargocompany/filter',
    DeleteShippingFeeManagement: Backofficebff + '/v1/foreign/cargocompany/delete',
    UpdateFastCargoManagement: Backofficebff + '/v1/cargo/update-fast-cargo-management',
};
